<template>
 
  <div>
  
    <b-alert variant="alertVariant"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <b-alert variant="success" dismissible :show="showSuccessDismissibleAlert" @dismissed="showSuccessDismissibleAlert=false">{{ successMsg }}   </b-alert>
    <div v-if="viewAdminMode">
  
      <b-card>
        <div slot="header">        
          <b-row>
            <b-col md="6" class="my-0">
              Status Updates
            </b-col>
            <b-col md="6" class="my-0" style="text-align:right">
              <b-button variant="info" @click="SendNotifications" :disabled="canSendNotifications">
                <strong class="text-white">Send Notifications</strong>
                <i title="Send Notifications" class="fa fa-lg text-white"></i>
              </b-button>
            </b-col>
          </b-row>
        </div>
        <dx-html-editor ref="htmlEditor" v-model="StatusItem.HTML" :height="300">
          <dx-toolbar>
            <dx-item format-name="undo" />
            <dx-item format-name="redo" />
            <dx-item format-name="separator" />
            <dx-item :format-values="sizeValues"
                     format-name="size" />
            <dx-item :format-values="fontValues"
                     format-name="font" />
            <dx-item format-name="separator" />
            <dx-item format-name="bold" />
            <dx-item format-name="italic" />
            <dx-item format-name="strike" />
            <dx-item format-name="underline" />
            <dx-item format-name="separator" />
            <dx-item format-name="alignLeft" />
            <dx-item format-name="alignCenter" />
            <dx-item format-name="alignRight" />
            <dx-item format-name="alignJustify" />
            <dx-item format-name="separator" />
            <dx-item :format-values="headerValues"
                     format-name="header" />
            <dx-item format-name="separator" />
            <dx-item format-name="orderedList" />
            <dx-item format-name="bulletList" />
            <dx-item format-name="separator" />
            <dx-item format-name="color" />
            <dx-item format-name="background" />
            <dx-item format-name="separator" />
            <dx-item format-name="link" />
            <dx-item format-name="image" />
            <dx-item format-name="separator" />
            <dx-item format-name="clear" />
            <dx-item format-nam="codeBlock" />
            <dx-item format-name="blockquote" />
            <dx-item :options="toolbarButtonOptions"
                     widget="dxButton" />
          </dx-toolbar>
        </dx-html-editor>
        <dx-popup :show-title="true"
                  :visible.sync="popupVisible" v-model="StatusItem.HTML"
                  title="Markup">
          <dx-text-area :value.sync="StatusItem.HTML" style="height:100%; margin-bottom:10px"></dx-text-area>
        </dx-popup>
        <b-row>
          <b-col md="6" class="my-0">
            <b-form-checkbox v-model="StatusItem.IS_VISIBLE">Is Visible</b-form-checkbox>
          </b-col>
          <b-col md="6" class="my-0" style="text-align:right">
            <b-button variant="info" @click="SaveStatus" :disabled="disableButtons">
              <strong class="text-white">Create New Active Message</strong>
              <i title="Save Status" class="fa fa-lg text-white"></i>
            </b-button>
            <div v-if="pageType===2">
              <b-button  variant="success" @click="AppendMsg" :disabled="disableButtons">
                <strong class="text-white">Append To The Last Active Message</strong>
                <i title="Append" class="fa fa-lg text-white"></i>
              </b-button>
            </div>
            
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <!-- User Interface controls -->
        <!-- search -->
        <b-row>
          <b-col md="6" class="my-0">
            <b-form-group class="my-1">
              <b-input-group v-on:keyup.enter="LoadData" v-on:keyup.escape="ClearSearch">
                <!--v-on:keyup.esc="ClearSearch"-->
                <b-form-input @keydown.native="EscClearSearch" v-model="tbxFilter" id="tbxFilter" placeholder="Type to search by Status Message" />
                <b-input-group-append>
                  <b-btn class="btn btn-default text-white ml-2" @click="ClearSearch">
                    <i class="fa fa-eraser" title="Clear Search"></i> <strong class="text-white">Clear</strong>
                  </b-btn>
                  <b-btn class="btn btn-warning text-white ml-2" @click="LoadData">
                    <i class="fa fa-search" title="Search"></i> <strong class="text-white">Search</strong>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col md="6" class="my-1"><div class="mr-2" style="text-align:right">Showing {{ GetRowCount() }} / {{ totalCount }} records</div></b-col>
        </b-row>
        <!-- Main table element -->
        <b-table id="tblMain" :items="FilteredRecords" selectable :select-mode="selMode" @row-dblclicked="showSelectedStatus" @row-clicked="selItem" hover striped bordered small :fields="fields" :current-page="currentPage" :per-page="perPage" show-empty>
          <template slot="CREATED_TS" slot-scope="row">
            {{row.value | formatDate}}
          </template>
          <template slot="IS_VISIBLE" slot-scope="row">
            {{row.value }}
          </template>
        </b-table>
        <!-- NAV -->
        <nav>
          <b-pagination :total-rows="GetRowCount(Items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
        </nav>
      </b-card>
      <b-card>
        <div slot="header">
          Notification Sent Logs
        </div>
        <b-table id="tblLogs" :items="LogItems" hover striped bordered small :fields="LogFields" :current-page="LogCurrentPage" :per-page="LogPerPage" show-empty>
          <template slot="CREATED_TS" slot-scope="row">
            {{row.value | formatDate}}
          </template>
        </b-table>
        <!-- NAV -->
        <nav>
          <b-pagination :total-rows="GetLogRowCount(LogItems)" :per-page="LogPerPage" v-model="LogCurrentPage" prev-text="Prev" next-text="Next" />
        </nav>
      </b-card>
      <b-card>
        <div slot="header">
          Notification Viewed Logs
        </div>
        <b-table id="tblViewedLogs" :items="LogViewedItems" hover striped bordered small :fields="LogViewedFields" :current-page="LogViewedCurrentPage" :per-page="LogViewedPerPage" show-empty>
          <template slot="CREATED_TS" slot-scope="row">
            {{row.value | formatDate}}
          </template>
        </b-table>ff
        <!-- NAV -->
        <nav>
          <b-pagination :total-rows="GetLogViewedRowCount(LogViewedItems)" :per-page="LogViewedPerPage" v-model="LogViewedCurrentPage" prev-text="Prev" next-text="Next" />
        </nav>
      </b-card>f
    </div>
    <div v-else>
      <div class="header">
        <h5>Latest  Status Message - Internal Incident Report Number: {{StatusItem.ID}} </h5>
        <h6>Message Created: {{StatusItem.CREATED_TS | formatDate}} by {{StatusItem.CREATED_BY}} </h6>
      </div>
      <div id="statusMsg" class="statusMsg" v-html="StatusItem.HTML"></div>
    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
    <b-modal id="modMsg" ref="modMsgRef" title="Data Updates Message" size="xl">
      <div v-html="SelectedItem.HTML"></div>
    </b-modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import loading from 'vue-full-loading'
  import moment from 'moment'
  import { setTimeout } from 'timers'
  import HL from 'highlight.js'

  import {
    DxHtmlEditor,
    DxToolbar,
    DxItem
  } from 'devextreme-vue/html-editor';

  import { DxPopup } from 'devextreme-vue/popup';

  import { DxTextArea } from 'devextreme-vue';

  export default {
    name: 'status-page',
    components: {
      loading,
      DxHtmlEditor,
      DxToolbar,
      DxItem,
      DxPopup,
      DxTextArea
    },
    props: {
      item: {
        type: Object,
        required: false
      },
      statusPageType: {
        type: Number,
        value: 1
      }

    },
    data() {
      return {
        errMsg: '',
        successMsg: '',
        showDismissibleAlert: false,
        showSuccessDismissibleAlert: false,
        txtLoading: 'Loading...',
        boolLoading: false,
        sendingNotifications: false,
        tbxFilter: undefined,
        intervalHandle: undefined,
        gettingData: false,
        gettingDataInterval: 5000,
        totalCount: 0,
        Items: [],
        itemsObject: {},
        fields: [
          { key: 'ID', label: 'ID', sortable: true },
          {
            key: 'CREATED_TS', label: 'Date', sortable: true, thStyle: { maxWidth: '200px', minWidth: '100px' }
          },
          { key: 'HTML', label: 'Message', sortable: true },
          { key: 'CREATED_BY', label: 'Created By', sortable: true },
          { key: 'IS_VISIBLE', label: 'Is Visible', sortable: true }
        ],
        currentPage: 1,
        perPage: 5,
        LogTotalCount: 0,
        LogItems: [],
        LogFields: [
          { key: 'ID', label: 'ID', visible: false },
          { key: 'CREATED_TS', label: 'Date', sortable: true },
          { key: 'CREATED_BY', label: 'Created By', sortable: true },
          { key: 'EMAIL_SENT', label: 'Email Sent', sortable: true },
          { key: 'SMS_SENT', label: 'SMS Sent', sortable: true },
          { key: 'ERROR_MSG', label: 'Error', sortable: true }
        ],
        LogCurrentPage: 1,
        LogPerPage: 5,
        LogViewedTotalCount: 0,
        LogViewedItems: [],
        LogViewedFields: [
          { key: 'ID', label: 'ID', sortable: true },
          { key: 'CREATED_TS', label: 'Date', sortable: true },
          { key: 'PARTNER_NAME', label: 'Viewed By', sortable: true }
        ],
        LogViewedCurrentPage: 1,
        LogViewedPerPage: 5,
        sizeValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
        fontValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'],
        headerValues: [false, 1, 2, 3, 4, 5],
        StatusItem: { ID: 0, HTML: '', SMS_TEXT: '', IS_VISIBLE: true, CREATED_TS: '', CREATED_BY: '', NOTIFICATION_TYPE_ID: this.statusPageType },
        SelectedItem: { ID: 0, HTML: '', SMS_TEXT: '', IS_VISIBLE: true, CREATED_TS: '', CREATED_BY: '', NOTIFICATION_TYPE_ID: this.statusPageType, APPEND: false },
        UserActionRights: [],
        viewAdminMode: false,
        selMode: 'single',
        popupVisible: false,
        toolbarButtonOptions: {
          text: 'Show markup',
          stylingMode: 'text',
          onClick: () => {
            let self = this
            this.popupVisible = true
          }
        },
        pageType: this.statusPageType
       
      }
    },
    created() {
      let self = this
      self.LoadData(true)
    },
    methods: {
      LoadData(onCreated) {
        let self = this

        if (self.gettingData === false) {
          if (onCreated !== true) {
            self.boolLoading = true
          }

          self.gettingData = true

          let obj = {
            q: self.tbxFilter,
            a: 2,
            n: self.pageType
          }

          let axiosConfig = {
            timeout: 60000
          }

          axios.post('/api/status/IsUserHasAdminRights', obj, axiosConfig)
            .then(response => {

              self.viewAdminMode = response.data

              if (self.viewAdminMode) {
                axios.post('/api/status/LoadStatusHistory', obj, axiosConfig)
                  .then(response => {
                    if (response.data == null || response.data.length==0) {
                      return;
                    }

                    self.errMsg = ''
                    self.showDismissibleAlert = false

                    self.totalCount = response.data.length
                    self.Items = response.data
                    self.SelectedItem = self.Items[0]
                    self.LoadLogs()
                    self.LoadViewedLogs()

                  })
                  .catch(error => {
                    if (error !== undefined && error.response !== undefined && error.response.status === 403) {
                      self.$router.push('/login')
                    }
                    self.errMsg = 'There was an error getting data : ' + ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
                    self.showDismissibleAlert = true
                  }).then(response => {
                    self.gettingData = false
                    self.boolLoading = false
                  })
              }
              else {
                axios.post('/api/status/LoadReadOnlyStatus', obj, axiosConfig)
                  .then(response => {
                    if (response.data == null || response.data.length == 0) {
                      return;
                    }
                    self.errMsg = ''
                    self.showDismissibleAlert = false
                    self.StatusItem = response.data
                  })
                  .catch(error => {
                    if (error !== undefined && error.response !== undefined && error.response.status === 403) {
                      self.$router.push('/login')
                    }
                    self.errMsg = 'There was an error getting data : ' + ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
                    self.showDismissibleAlert = true
                  }).then(response => {
                    self.gettingData = false
                    self.boolLoading = false
                  })
              }

            })


        }
      },
      GetRowCount() {
        let self = this
        return self.FilteredRecords.length
      },
      GetLogRowCount() {
        let self = this
        return self.LogItems.length
      },
      GetLogViewedRowCount() {
        let self = this
        return self.LogViewedItems.length
      },
      ClearSearch() {
        let self = this
        self.tbxFilter = undefined
        self.LoadData()
      },
      ClearStatusItem() {
        let self = this
        self.StatusItem = { ID: 0, HTML: '', SMS_TEXT: '', IS_VISIBLE: true, CREATED_TS: '', CREATED_BY: '', NOTIFICATION_TYPE_ID: self.pageType }
      },
      EscClearSearch(event) {
        let self = this
        if (event.key === 'Escape') {
          self.ClearSearch()
        }
      },
      UNescapeHtml(str) {
        str = str.replace(/&amp;/g, '&')
        str = str.replace(/&lt;/g, '<')
        str = str.replace(/&gt;/g, '>')
        str = str.replace(/&quot;/g, '"')
        str = str.replace(/&#39;/g, "'")
        str = str.replace(/&#x2F;/g, '/')
        str = str.replace(/&#x60;/g, '`')
        str = str.replace(/&#x3D;/g, '=')
        str = str.replace(/&nbsp;/g, ' ')

        return str
      },
      escapeHtml(string) {
        var entityMap = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;',
          '/': '&#x2F;',
          '`': '&#x60;',
          '=': '&#x3D;'
        }
        return String(string).replace(/[&<>"'`=\/]/g, function (s) {
          return entityMap[s]
        })
      },
      NewLiner(str) {
        if (str === undefined || str === null) {
          return ''
        }
        str = str.replace(/\r\n/g, '<br>')
        return str
      },
      SpaceRemover(str) {
        if (str === undefined || str === null) {
          return ''
        }
        str = str.replace(/ {8}/g, '&nbsp;')
        str = str.replace(/ {7}/g, '&nbsp;')
        str = str.replace(/ {6}/g, '&nbsp;')
        str = str.replace(/ {5}/g, '&nbsp;')
        str = str.replace(/ {4}/g, '&nbsp;')
        str = str.replace(/ {3}/g, '&nbsp;')
        str = str.replace(/ {2}/g, '&nbsp;')
        str = str.replace(/ /g, '&nbsp;')
        // str = str.replace(/:{/g, ':&lt;br&gt;{')
        // str = str.replace(/},/g, '},&lt;br&gt;')
        return str
      },
      Prettify(str) {
        if (str === undefined || str === null) {
          return ''
        }
        let self = this

        str = self.SpaceRemover(str)
        str = self.UNescapeHtml(str)

        let hlObject = HL.highlightAuto(str, ['cs', 'swift', 'csharp', 'xml', 'json', 'cmd'])

        str = hlObject.value
        return str
      },
      SendNotifications() {
        let self = this

        let message = 'Are you sure you would like to run it?'
        let options = {
          html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
          reverse: false, // switch the button positions (left to right, and vise versa)
          okText: 'Continue',
          cancelText: 'Close',
          animation: 'zoom', // Available: "zoom", "bounce", "fade"
          type: 'soft', // 'basic', // coming soon: 'soft', 'hard'
          verification: 'I know better', // for hard confirm, user will be prompted to type this to enable the proceed button
          verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
          clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
          backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
          customClass: '' // Custom class to be injected into the parent node for the current dialog instance
        }

        self.$dialog.confirm(message, options)
          .then(function () {
            self.sendingNotifications = true
            let axiosConfig = {
              timeout: 60000
            }
            axios.post('/api/status/SendStatusUpdates', self.StatusItem, axiosConfig)
              .then(response => {
                self.sendingNotifications = false
                self.successMsg = response.data
                self.showSuccessDismissibleAlert = true
                self.tbxFilter = undefined
                self.LoadLogs()
              })
              .catch(error => {
                self.sendingNotifications = true
                if (error !== undefined && error.response !== undefined && error.response.status === 403) {
                  self.$router.push('/login')
                }
                self.errMsg = 'There was an error sending notifications : ' + ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
                self.showDismissibleAlert = true
              })
          })
          .catch(function () {

          })

      },
      AppendMsg() {
        let self = this
        self.StatusItem["APPEND"] = true
        self.SaveStatus()
      },
      SaveStatus() {
        let self = this

        let message = 'Are you sure you would like to run it?'
        let options = {
          html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
          reverse: false, // switch the button positions (left to right, and vise versa)
          okText: 'Continue',
          cancelText: 'Close',
          animation: 'zoom', // Available: "zoom", "bounce", "fade"
          type: 'soft', // 'basic', // coming soon: 'soft', 'hard'
          verification: 'I know better', // for hard confirm, user will be prompted to type this to enable the proceed button
          verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
          clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
          backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
          customClass: '' // Custom class to be injected into the parent node for the current dialog instance
        }

        self.$dialog.confirm(message, options)
          .then(function () {
            let axiosConfig = {
              timeout: 60000
            }

            axios.post('/api/status/save', self.StatusItem, axiosConfig)
              .then(response => {
                self.errMsg = ''
                self.showDismissibleAlert = false
                self.Items = response.data
                self.StatusItem = { ID: 0, HTML: '', SMS_TEXT: '', IS_VISIBLE: true, CREATED_TS: '', CREATED_BY: '', NOTIFICATION_TYPE_ID: self.pageType }
                self.tbxFilter = undefined
              })
              .catch(error => {
                if (error !== undefined && error.response !== undefined && error.response.status === 403) {
                  self.$router.push('/login')
                }
                self.errMsg = 'There was an error saving  data : ' + ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
                self.showDismissibleAlert = true
              })
          })
          .catch(function () {

          })

      },
      LoadLogs() {
        let self = this
        let axiosConfig = {
          timeout: 60000
        }
        let obj = {
          n: self.pageType,
          id: self.SelectedItem.ID
        }
        axios.post('/api/status/LoadNotificationsLog', obj, axiosConfig)
          .then(response => {
            self.errMsg = ''
            self.showDismissibleAlert = false

            self.LogTotalCount = response.data.length
            self.LogItems = response.data

          })
          .catch(error => {
            if (error !== undefined && error.response !== undefined && error.response.status === 403) {
              self.$router.push('/login')
            }
            self.errMsg = 'There was an error getting log data : ' + ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
            self.showDismissibleAlert = true
          }).then(response => {
            self.gettingData = false
            self.boolLoading = false
          })
      },
      LoadViewedLogs() {
        let self = this
        let axiosConfig = {
          timeout: 60000
        }
        let obj = {
          n: self.pageType,
          id: self.SelectedItem.ID
        }
        axios.post('/api/status/LoadNotificationsViewedLog', obj, axiosConfig)
          .then(response => {
            self.errMsg = ''
            self.showDismissibleAlert = false

            self.LogViewedTotalCount = response.data.length
            self.LogViewedItems = response.data

          })
          .catch(error => {
            if (error !== undefined && error.response !== undefined && error.response.status === 403) {
              self.$router.push('/login')
            }
            self.errMsg = 'There was an error getting log data : ' + ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
            self.showDismissibleAlert = true
          }).then(response => {
            self.gettingData = false
            self.boolLoading = false
          })
      },
      selItem(row) {
        let self = this
        self.SelectedItem = row
        self.LoadLogs()
        self.LoadViewedLogs()
      },
      showSelectedStatus(row) {
        let self = this
        self.SelectedItem = row
        this.$refs.modMsgRef.show()
      }
    },
    filters: {
      formatDate: function (date) {
        var m = moment(date)
        m.isUTC = true;
        if (m.isValid()) {
          return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY hh:mm a')
        }
        return ''
      },
      formatDateToNow: function (date) {
        var m = moment(date)
        if (m.isValid()) {
          let localTime = m.add(moment().utcOffset(), 'm')
          return localTime.toNow(true) + ' ago'
        }
        return ''
      }
    },
    computed: {
      FilteredRecords: function () {
        let self = this

        if (self.boolLoading) {
          return []
        } else {
          return self.Items
        }
      },
      disableButtons: function () {
        return (this.StatusItem.HTML == '' || this.StatusItem.HTML == '<br>')
      },
      canSendNotifications: function () {
        var lastItem = this.Items[0]
        var lastItemVisible = false
        if (lastItem != null) {
          lastItemVisible = lastItem.IS_VISIBLE
        }
        return (!this.StatusItem.IS_VISIBLE || !lastItemVisible || this.sendingNotifications)
      }
    },
    mounted() {
      let self = this

      self.boolLoading = true
    }
  }
</script>

<style type="text/css">
  .hljs {
    background: transparent;
  }

  .wordwrap {
    font-size: 87.5%;
    white-space: pre-wrap; /* CSS3 */
    white-space: -moz-pre-wrap; /* Firefox */
    white-space: -pre-wrap; /* Opera <7 */
    white-space: -o-pre-wrap; /* Opera 7 */
    word-wrap: break-word; /* IE */
  }

  .dx-htmleditor-content img {
    vertical-align: middle;
    padding-right: 10px;
  }

  .statusMsg {
    background-color: whitesmoke;
    min-height: 300px;
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/StatusPage.vue